import React from 'react';

type Specification = {
  attribute_name: string;
  attribute_value: string;
};

interface GroupedSpecs {
  [key: string]: string[];
}

const SpecificationsTab = ({ specifications }: { specifications: Specification[] }) => {
  const grouped: GroupedSpecs = {};
  specifications.forEach(({ attribute_name, attribute_value }) => {
    if (!grouped[attribute_name]) grouped[attribute_name] = [];
    grouped[attribute_name].push(attribute_value);
  });

  return (
    <div className="product-tab-content specification-tab">
      {Object.entries(grouped).map(([name, values]) => (
        <div key={name} className="spec-row">
          <div className="spec-label">{name}</div>
          <div className="spec-values">
            {values.map((val, i) => (
              <div key={i} className="spec-value">{val}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SpecificationsTab;
